// extracted by mini-css-extract-plugin
export default {"assignees_cell":"AssigneesCell_assignees_cell__jeA1P"};